import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        window.location.reload();
    })
};


const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
        meta: {
            login: false
        },
    },
    {
        path: '/',
        name: 'layout',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/components/dashboard.vue'),
        meta: {
            login: true,
        },
        children: [
            {
                path: 'artifact',
                name: 'artifact',
                component: () => import(/* webpackChunkName: "artifact" */ '@/views/artifact/index.vue'),
                meta: {
                    login: true,
                },
            },
            {
                path: 'artifact/add',
                name: 'artifact-add',
                component: () => import(/* webpackChunkName: "artifact" */ '@/views/artifact/add.vue'),
                meta: {
                    login: true,
                },
            },
            {
                path: 'artifact/edit/:id',
                name: 'artifact-edit',
                component: () => import(/* webpackChunkName: "artifact" */ '@/views/artifact/edit.vue'),
                meta: {
                    login: true,
                },
            },
            {
                path: 'info',
                name: 'info',
                component: () => import(/* webpackChunkName: "info" */ '@/views/admin/index.vue'),
                meta: {
                    login: true,
                },
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes
})

export default router

